import React from 'react';
import { tierLabel } from '@/lib/granularity';
import Snowflake from '@/Components/Snowflake';

/**
 * What a property is called by machines: its own id, and — when the property is
 * reported — the EU registry's name for it.
 *
 * The two are not the same kind of fact and must not read as one list. The
 * property id is internal plumbing, useful for an import mapping or an API
 * call; the data element is a commitment to a regulator about what leaves the
 * building. So the mapping gets its own panel rather than another line: an
 * author scanning a passport should be able to tell at a glance whether this
 * field is reported, without reading either value.
 *
 * Kept out of ValueField because the card it sits in only mounts on hover,
 * which puts it beyond the reach of a test that has to stay fast.
 */
export default function PropertyIdentity({ propertyId, dataElementId = null, tier = null }) {
    return (
        <>
            <p className="text-xs font-medium tracking-wide text-gray-500 uppercase">
                Property ID
            </p>
            <p className="mt-1">
                <Snowflake id={propertyId} />
            </p>
            {dataElementId && (
                <div className="px-3 py-2 mt-3 rounded-md bg-emerald-50 ring-1 ring-inset ring-emerald-100">
                    <p className="text-xs font-medium text-emerald-800">
                        Reported to the EU registry
                        {tier ? ` as ${tierLabel(tier)}` : ''}
                    </p>
                    <p className="mt-0.5 font-mono text-sm text-emerald-900 break-all">
                        {dataElementId}
                    </p>
                </div>
            )}
        </>
    );
}
